import { useCallback, useMemo, useState } from "react";
import CustomAlert from "../Components/Common/Alert";

const useStatusToast = () => {
  const [toastState, setToastState] = useState({
    message: "",
    type: "success",
    isOpen: false,
  });

  const showToast = useCallback((type, message) => {
    if (!message) return;
    setToastState({
      message,
      type,
      isOpen: true,
    });
  }, []);

  const toastPortal = useMemo(
    () => (
      <CustomAlert
        message={toastState.message}
        type={toastState.type}
        isOpen={toastState.isOpen}
        onClose={() => setToastState((prev) => ({ ...prev, isOpen: false }))}
      />
    ),
    [toastState]
  );

  return {
    showSuccess: (message) => showToast("success", message),
    showError: (message) => showToast("error", message),
    ToastPortal: toastPortal,
  };
};

export default useStatusToast;
